import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const scrollToTop = () => {
  window.scrollTo(0, 0)
}

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-content'>

        <div className='footer-section footer-brand'>
          <h3>ArrAndArr</h3>
          <p>Premium Royal Canin pet nutrition for your furry family members.</p>
        </div>

        <div className='footer-section footer-links'>
          <h4>Quick Links</h4>
          <Link to='/' onClick={scrollToTop}>Home</Link>
          <Link to='/AboutUs' onClick={scrollToTop}>About Us</Link>
          <Link to='/ContactUs' onClick={scrollToTop}>Contact Us</Link>
          <Link to='/ShippingDelivery' onClick={scrollToTop}>Shipping &amp; Delivery</Link>
          <Link to='/PrivacyPolicy' onClick={scrollToTop}>Privacy Policy</Link>
          <Link to='/TermsConditions' onClick={scrollToTop}>Terms &amp; Conditions</Link>
        </div>

        <div className='footer-section footer-links'>
          <h4>Categories</h4>
          <Link to='/DogProducts' onClick={scrollToTop}>Dog Products</Link>
          <Link to='/CatProducts' onClick={scrollToTop}>Cat Products</Link>
        </div>

        <div className='footer-section footer-contact'>
          <h4>Contact</h4>
          <p>Email: info@arrandarr.com</p>
        </div>

      </div>

      <div className='footer-bottom'>
        <hr />
        <p>&copy; {new Date().getFullYear()} ArrAndArr. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
